<template>
    <div class="tutorials">
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-20 md-medium-size-30 md-xsmall-hide md-elevation-4">
                <h2 class="md-title">Jump to:</h2>
                <md-list >
                    <md-list-item href="#map-interface">
                        <span class="md-list-item-text">Map Interface</span>
                    </md-list-item>

                    <md-list-item href="#areas-1">
                        <span class="md-list-item-text">Adding areas (part 1)</span>
                    </md-list-item>

                    <md-list-item href="#areas-2">
                        <span class="md-list-item-text">Adding areas (part 2)</span>
                    </md-list-item>

                    <md-list-item href="#areas-3">
                        <span class="md-list-item-text">Adding areas (part 3)</span>
                    </md-list-item>
                </md-list>
            </div>
            <div class="md-layout-item md-elevation-4">
                <h2 class="md-headline">Tutorials</h2>
                <p>
                    Below is a compilation of video tutorial resources on how to create Earth Observation workflows using EarthBlox.
                </p>
                <ul>
                    <md-divider></md-divider>
                    <li>
                        <h3 id="map-interface" class="md-title">Map Interface</h3>
                        <p>Learn how to draw areas, how to upload vector files, coordinates etc.</p>
                        <iframe :width="frameWidth" :height="frameHeight" frameborder="0" 
                            sandbox="allow-scripts allow-same-origin" 
                            src="https://www.youtube-nocookie.com/embed/qQeF5qUt6g4" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </li>
                    <md-divider></md-divider>
                    <li>
                        <h3 id="areas-1" class="md-title">Adding areas (part 1)</h3>
                        <p>How to draw polygons in the workspace map to define your region of interest.</p>
                        <iframe :width="frameWidth" :height="frameHeight" frameborder="0" 
                            sandbox="allow-scripts allow-same-origin" 
                            src="https://www.youtube-nocookie.com/embed/qQeF5qUt6g4" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </li>
                    <md-divider></md-divider>
                    <li>
                        <h3 id="areas-2" class="md-title">Adding areas (part 2)</h3>
                        <p>Working with map coordinates.</p>
                        <iframe :width="frameWidth" :height="frameHeight" frameborder="0" 
                            sandbox="allow-scripts allow-same-origin" 
                            src="https://www.youtube-nocookie.com/embed/qQeF5qUt6g4" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </li>
                    <md-divider></md-divider>
                    <li>
                        <h3 id="areas-3" class="md-title">Adding areas (part 3)</h3>
                        <p>Upload a custom vector file to define your region of interest.</p>
                        <iframe :width="frameWidth" :height="frameHeight" frameborder="0" 
                            sandbox="allow-scripts allow-same-origin" 
                            src="https://www.youtube-nocookie.com/embed/qQeF5qUt6g4"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AnalyticsService } from "@/services/analytics.service";
import { GA_EVENTS } from "@/constants/gaConstants.js";

export default {
    name: "Tutorials",
    data: () => ({
        frameWidth: 1200,  
        frameHeight: 630
    }),
    created() {
        AnalyticsService.logAnalyticsEvent(GA_EVENTS.PAGE_TUTORIALS);
        console.log("Tutorials.vue  created");
    }
};
</script>

<style scoped lang="scss">
    $frameHeight: 630px;

    .tutorials .md-card-content {
        padding-left: 0;
    }

    .tutorials ul {
        list-style-type: none;
        padding: 0;

        li {
            margin-bottom: 20px;
        }
    }

    .tutorials li .md-subheading {
        margin-bottom: 20px;
    }

    .tutorials iframe {
        height: $frameHeight;
    }
    @media only screen and (min-width: 600px) {
        .tutorials {
            padding-left: 55px;
            padding-right: 55px;
        }
    }
</style>